import { User } from "@/types";
import { capitalize } from "vue-demi";

export function fullName(user: User) {
  return capitalize(user.first_name) + " " + capitalize(user.last_name);
}
